<template>
    <div class="d-inline-block">
        <button class="ix-btn ix-btn-state ix-page-header-action" type="button" @click="showModal()" v-bind:class="{'green': is_accounted && !loading}">
            Comptabiliser
            <span v-if="is_accounted && !loading"><i class="far fa-check"></i></span>
            <span v-if="!is_accounted && !loading"><i class="far fa-exclamation-circle"></i></span>
        </button>


        <div class="modal fade" id="affectAccountingAccountsModal" tabindex="0" aria-labelledby="affectAccountingAccountsModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="far fa-balance-scale-left"></i> Affectation au plan comptable</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="ix-comments-loader" v-if="loading">
                            <i class="far fa-circle-notch fa-spin"></i> Récupération des informations en cours
                        </div>

                        <div v-show="!loading">
                            <div class="ix-table-box">
                                <table class="ix-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center col-4">Compte</th>
                                            <th class="text-center col-4">Débit</th>
                                            <th class="text-center col-4">Crédit</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(account, index) in accounts" :key="index">
                                            <td class="col-4">
                                                <span v-html="truncate(account.designation, 75)"></span>
                                            </td>
                                            <td class="col-4">
                                                <div class="input-group input-group-sm">
                                                    <input type="number" class="form-control text-right debit" v-model="account.debit" :disabled="account.credit !== null" @input="resetFields(index)" step="0.01">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">€</span>
                                                    </div>
                                                </div>
                                            </td> 
                                            <td class="col-4">
                                                <div class="input-group input-group-sm">
                                                    <input type="number" class="form-control text-right credit" v-model="account.credit" :disabled="account.debit !==null" @input="resetFields(index)" step="0.01">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">€</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-right">
                                                <button type="button" class="btn btn-sm transparent" @click="deleteRow(index)">
                                                    <i class="far fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="100%">
                                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="accountsAutocomplete" type="text" v-model="accountSearch">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    
                    <div class="modal-body" v-show="!loading">
                        <!-- tableau recapitulatif-->
                        <div class="ix-table-box">
                            <table class="ix-table">
                                <tbody>
                                    <tr>
                                        <td class="text-center sum col-4">Totaux</td>
                                        <td class="text-center col-4" id="sum-debit" :style="{color: sumColor}">{{ sumDebit.toFixed(2) }} €</td>
                                        <td class="text-center col-4" id="sum-credit" :style="{color: sumColor}">{{ sumCredit.toFixed(2) }} €</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-footer" v-show="!loading">
                        <button type="submit" class="ix-btn green" v-bind:disabled="!checkForm() || loadingForm" @click="update()">  
                            <span v-if="!loadingForm">Enregistrer</span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AccountingAccountsAffectation",
        props : {
            model : String,
            id : Number,
            order : String,
            suggestionsUrl : "",
            patchUrl : "",
            accountsUrl : ""
        },
        data() {
            return {
                loading: false,
                loadingForm: false,

                accounts: [],
                allowed_classes: [],

                accountSearch: null,
                total_to_affect: 0,
                is_accounted: false,
                credit_note_provider: false,
            }
        },
        computed: {
            total_affected: function() {
                var sum = 0;
                this.accounts.forEach(account => {
                    if(account.state == null){
                        if(account.debit != null){
                            account.amount = account.debit
                            account.state = 0
                        }else if(account.credit != null){
                            account.amount = account.credit
                            account.state = 1
                        }
                    }
                    else if(account.state == 0){
                        account.amount = account.debit
                    }else if(account.state == 1){
                        account.amount = account.credit
                    }
                }) 
                this.accounts.forEach(account => sum += parseFloat(account.amount));
                
                return this.roundCurrency(sum, 2)
            },
            sumDebit() {
                let sum = 0;
                this.accounts.forEach(account => {
                    if (account.state === 0 || account.state === null) {
                    sum += parseFloat(account.debit) || 0;
                    }
                });
                return sum;
                },
            sumCredit() {
                let sum = 0;
                this.accounts.forEach(account => {
                    if (account.state === 1 || account.state === null) {
                    sum += parseFloat(account.credit) || 0;
                    }
                });
                return sum;
            },
            sumColor() {
                return this.sumDebit.toFixed(2) == this.sumCredit.toFixed(2) ? 'green' : 'red';
            }
        },
        methods : {
            async getData() {
                this.loading = true;
                fetch(this.suggestionsUrl +  "?model=" + this.model +  "&id=" + this.id, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loading = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                           data.accounts.forEach(account => this.addRow(account))
                           this.total_to_affect = data.total_to_affect
                           this.is_accounted = data.is_accounted
                           if(data.credit_note_provider)
                                this.credit_note_provider = true;
                        })
                        
                    } 
                }).catch(error => {
                    this.loading = false
                    console.log(error)
                });
            },
            showModal() {
                $('#affectAccountingAccountsModal').modal()
            },
            getCurrentSelectedAccountsId: function() {
                return this.accounts.map(account => account.id);
            },
            addRow(account) {
                if (this.getCurrentSelectedAccountsId().includes(account.id) == false) {
                    this.accounts.push({
                        id: account.id,
                        designation: account.designation,
                        debit: account.state === 0 ? account.amount : null,
                        credit: account.state === 1 ? account.amount : null,
                        state: account.state,
                        description: account.description,
                    })
                }
            },
            deleteRow(index) {
                this.accounts.splice(index, 1)
            },
            checkForm() {
                var unfilledAmount = this.accounts.filter(account => { 
                    return account.debit === null && account.credit === null }).length

                console.log(unfilledAmount , this.total_affected , this.total_to_affect);
                
                return (Math.round(this.total_affected * 1000) / 1000 == Math.round(this.total_to_affect * 1000) / 1000  && unfilledAmount == 0) || this.accounts.length == 0
            },
            resetFields(index) {
                // si le debit est une chain vide on le met à null
                if (this.accounts[index].debit === "") {
                    this.accounts[index].debit = null
                    this.accounts[index].state = null
                }
                // si le credit est une chain vide on le met à null
                if (this.accounts[index].credit === "") {
                    this.accounts[index].credit = null
                    this.accounts[index].state = null
                }
            },

            async update() {
                this.loadingForm = true
                var data = {
                    accounts: this.accounts,
                    model: this.model,
                    id: this.id,
                    credit_note_provider : this.credit_note_provider
                }

                fetch(this.patchUrl, {
                    ...{
                        method: 'PUT',
                        body :  JSON.stringify(data)
                    },
                    ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    this.loadingForm = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.is_accounted = data
                            $('#affectAccountingAccountsModal').modal('hide');
                        })
                    }
                }).catch(error => {
                    this.loadingForm = false
                    console.log(error)
                });
            },
        },
        async mounted(){
            $("#accountsAutocomplete").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.accountsUrl,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {q: request.term, '!id': this.getCurrentSelectedAccountsId().join(';')},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if (!item.item) {
                        $(e.target).val("")
                        this.deal = null
                    }
                },
                select: (e, item) => {
                    $(e.target).val("")
                    this.addRow(item.item)
                    this.accountSearch = null
                }
            }).focus(() => {
                $("#accountsAutocomplete").autocomplete("search", '');
            });

            await this.getData()
        }
    }
</script>
